/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from 'react';

const sections = ['entry', 'exit', 'filter', 'risk', 'fill', 'engine'];

const TraceFilters = ({
  value,
  onChange,
  onApply,
  onClear,
  disabled,
}) => {
  const { bar_index, ts, section, kind, limit } = value || {};

  const set = (k, v) => onChange({ ...value, [k]: v });

  return (
    <div className="flex flex-wrap items-end gap-3">
      <div>
        <label className="block text-xs text-textSecondary">Bar Index</label>
        <input type="number" className="input input-sm" value={bar_index ?? ''} onChange={(e) => set('bar_index', e.target.value ? Number(e.target.value) : undefined)} />
      </div>
      <div>
        <label className="block text-xs text-textSecondary">Timestamp (ISO or epoch)</label>
        <input type="text" className="input input-sm" value={ts ?? ''} onChange={(e) => set('ts', e.target.value || undefined)} />
      </div>
      <div>
        <label className="block text-xs text-textSecondary">Section</label>
        <select className="select select-sm" value={section ?? ''} onChange={(e) => set('section', e.target.value || undefined)}>
          <option value="">All</option>
          {sections.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-xs text-textSecondary">Kind</label>
        <input type="text" className="input input-sm" value={kind ?? ''} onChange={(e) => set('kind', e.target.value || undefined)} />
      </div>
      <div>
        <label className="block text-xs text-textSecondary">Limit</label>
        <input type="number" className="input input-sm" value={limit ?? 200} onChange={(e) => set('limit', e.target.value ? Number(e.target.value) : 200)} />
      </div>
      <div className="flex gap-2">
        <button className="btn btn-sm" onClick={onApply} disabled={disabled}>Apply</button>
        <button className="btn btn-sm btn-ghost" onClick={onClear} disabled={disabled}>Clear</button>
      </div>
    </div>
  );
};

export default TraceFilters;
